import { render } from "./OrgSearch.vue?vue&type=template&id=7e12ed3d"
import script from "./OrgSearch.vue?vue&type=script&lang=js"
export * from "./OrgSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__